import environmentsConfig from '../config/environments.json';

type Environment =
  | 'main'
  | 'staging'
  | 'unstable'
  | 'stable'
  | 'dev'
  | 'local'
  | 'production';

export const getCurrentEnvironment = (): Environment => {
  if (typeof window !== 'undefined') {
    const origin: string = (window as any)?.location?.origin || '';
    if (origin.includes('ims.ufa.com.lb')) {
      return 'main';
    }
    if (origin.includes('staging')) {
      return 'staging';
    } else if (origin.includes('ufa-ui.nicesky')) {
      return 'production';
    } else if (origin.includes('unstable')) {
      return 'unstable';
    } else if (origin.includes('stable')) {
      return 'stable';
    } else if (origin.includes('dev')) {
      return 'dev';
    }
  } else {
    return 'dev';
  }

  return 'dev';
};

export interface IEnviromentData {
  graphBaseUrl: string;
  mainHostUrl: string;
  identityBaseUrl: string;
  identityRedirectUrl: string;
}

export const getEnviromentDetails = (): IEnviromentData => {
  const currentEnv = getCurrentEnvironment();

  // Get configuration from JSON file
  const envConfig =
    environmentsConfig[currentEnv as keyof typeof environmentsConfig];

  if (envConfig) {
    return envConfig;
  }

  // Fallback to dev configuration if environment not found
  return environmentsConfig.dev;
};

export const isProd = () => {
  const origin: string = (window as any)?.location?.origin || '';

  return origin.includes('ims.ufa.com.lb');
};

export const TinyMCEApiKey = '1zpxcry8s9a6chrmtwzhr9g4fpr8m1fywjo4eq76vdj33per';
